import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SaleInvoiceForm from '../../components/pageModule/Saleinvoices/SaleInvoiceForm';
import { createSaleInvoice, setSelected, clearCurrentSaleInvoice } from '../../store/modules/saleinvoice/saleinvoiceActions';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const SaleinvoicesCreate = () => {
    const initialData = useRef({ initialType: 'create' });
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Clear any existing data when component mounts
    useEffect(() => {
        dispatch(clearCurrentSaleInvoice());
    }, [dispatch]);

    const handleCreate = async (formData) => {
        try {
            const response = await dispatch(createSaleInvoice(formData));
            toast.success('Sale invoice created successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            if (response && response.id) {

                navigate(`/sale_invoices/view/${response.id}?preview=true`);

                // navigate(`/sale_invoices/edit/${response.id}`);
            }
            return response;
        } catch (error) {
            toast.error(error.message || 'Error creating sale invoice', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        create: handleCreate,
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
    };
    
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <SaleInvoiceForm 
                                    initialData={initialData.current}
                                    onSave={async (data) => {
                                        try {
                                            const response = await actions.create(data);
                                            return response;
                                        } catch (error) {
                                            console.error('Error creating item:', error);
                                            throw error;
                                        }
                                    }}
                                    onClose={() => {
                                        console.log('cancel btn clicked')
                                    }}
                                    customActionsDispatch={actions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SaleinvoicesCreate; 